import { IconButton, Icons } from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";

interface IBackButton {
    onClick: () => void;
}

const BackButton: React.FC<IBackButton> = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <IconButton
            aria-label={t("back")}
            icon={Icons.Back}
            variant="ghost"
            onClick={onClick}
            data-track-click="stepper-back"
        />
    );
};

export default BackButton;
